export default {
    // 模态框/弹出层相关
    modal: {
        logout: {
            title: '退出登录',
            message: '确定要退出登录吗？',
        },
        confirm: {
            title: '确认',
            message: '确定要继续吗？',
        },
    },

    // 下拉选择相关
    dropdown: {
        selectOption: '请选择一个选项',
        noOptions: '没有可选择的选项',
    },

    // 表格相关
    table: {
        headers: {
            item: '项目',
            content: '内容',
            activity: '活动',
            mode: '模式',
            result: '结果',
            time: '时间',
            student: '学生',
            answer: '答案',
            score: '分数',
            status: '状态',
        },
        noData: '暂无数据',
        loading: '加载中...',
    },

    // 表单相关
    form: {
        required: '此项为必填项',
        invalid: '格式不正确',
        saved: '已保存',
        errors: {
            network: '发生网络错误',
            validation: '请重新确认输入信息',
            server: '发生服务器错误',
        },
    },

    // 加载/状态相关
    loading: {
        default: '加载中...',
        saving: '保存中...',
        processing: '处理中...',
        connecting: '连接中...',
    },

    // 通知/提示相关
    toast: {
        success: '操作已成功完成',
        error: '发生错误',
        warning: '请注意',
        info: '请查看信息',
    },
};
